import type { RegistersFilters } from "@services/registers/list/type";

export const defaultFilters: RegistersFilters = {
  type: "",
  reporterId: "",
  individualId: "",
  taxonomicGroupId: "",
  registerDateStart: "",
  registerDateEnd: "",
};
